import(/* webpackMode: "eager", webpackExports: ["ProductPage"] */ "/vercel/path0/src/components/ProductPage/ProductPage.tsx");
